// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesExam = {
  examAttempt: "考试作答",
  examExam: "考试",
  examPaper: "试卷",
  examPaperItem: "试题条目",
  examPaperVersion: "试卷版本",
  examPlatform: "考试平台",
  examReview: "考试评阅",
  examUser: "考试用户",
  examAuth: "考试认证",
  examScoring: "考试评分",
  examSystem: "考试系统",
  examExecutionFabric: "考试 Execution Fabric",
  examTaskCenter: "考试任务中心",
} as const;
